import React from "react";
import { Calendar } from "@/components/ui/calendar";
import { cn } from "@/lib/utils";

/**
 * BrandCalendar: the modernised Calendar wrapped in a brand-aware card
 * surface (shadow + radius from brand tokens), with an optional small-caps
 * footer for Clear / Today actions in the brand's text colour.
 *
 * All visual identity (claret, coral, white-gold, navy) flows through the
 * underlying Calendar via the surrounding CSS-token theme; this wrapper only
 * supplies the elevated card and the footer actions.
 */
export const BrandCalendar = ({
  className,
  showActions = true,
  onClear,
  onToday,
  todayLabel = "Today",
  clearLabel = "Clear",
  ...calendarProps
}) => {
  return (
    <div
      className={cn(
        "bg-[hsl(var(--card))] border border-border",
        "rounded-[var(--radius)] shadow-[var(--shadow-elev-2)]",
        "overflow-hidden",
        className
      )}
      data-testid="brand-calendar"
    >
      <Calendar {...calendarProps} />
      {showActions && (
        <div
          className={cn(
            "flex items-center justify-end gap-5",
            "px-4 py-3 border-t border-border",
            "bg-[hsl(var(--card))]"
          )}
        >
          <button
            type="button"
            onClick={onToday}
            className={cn(
              "text-[11px] font-medium uppercase tracking-[0.18em]",
              "text-foreground/70 hover:text-foreground",
              "transition-colors"
            )}
            data-testid="calendar-today"
          >
            {todayLabel}
          </button>
          <button
            type="button"
            onClick={onClear}
            className={cn(
              "text-[11px] font-medium uppercase tracking-[0.18em]",
              "text-foreground/70 hover:text-foreground",
              "transition-colors"
            )}
            data-testid="calendar-clear"
          >
            {clearLabel}
          </button>
        </div>
      )}
    </div>
  );
};

export default BrandCalendar;
